import React from "react";
import { RoutePermittedRole } from "shared/constants/AppConst";

export const UserFormConfig = [
  {
    permittedRole: RoutePermittedRole.User,
    path: "/user-form",
    component: React.lazy(() => import("./user-from")),
  },
];
